module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Home":"Home","Modules":"Modules","Messages":"Messages","Clients":"Clients","Profile":"Profile","Login":"Login","Logout":"Logout"},"nl":{"Home":"Home","Modules":"Modules","Messages":"Berichten","Clients":"Cliënten","Profile":"Profiel","Login":"Inloggen","Logout":"Uitloggen"}}')
  delete Component.options._Ctor
}
